import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { YearOfPassingService } from '@app/_services/masters/yearOfPassing.service';
import { LogService } from '@app/_shared/log.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-passing-year-master',
  templateUrl: './passing-year-master.component.html',
  styleUrls: ['./passing-year-master.component.css']
})
export class PassingYearMasterComponent implements OnInit {
  
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  delMessage: string;
  years;
  deleteYearId;
  getresponse: any;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private modalService: NgbModal,private eventService: LogService, private yearOfPassingService: YearOfPassingService) { }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.yearOfPassingService.getYears()
      .pipe(first())
      .subscribe(
        data => {
          console.log("document response---", data)
          this.years = data.respData;
          console.log("years---", this.years)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )

  }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  passData(dataValue, data) {
    this.eventService.emit({ dataValue, data });
  }

  deleteYear(id){
    console.log(id);
    this.deleteYearId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('35');
  }

  deleteYr(){
    this.yearOfPassingService.deleteYear(this.deleteYearId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("College response---", data)
          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            this.yearOfPassingService.getYears()
              .pipe(first())
              .subscribe(
                data => {
                  this.delMessage="Year Deleted Successfully."
                  console.log("College response---", data)
                  this.years = data.respData;
                  //this.dtTrigger.next();
                },
                error => {
                  console.log(error)
                }
              )
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage=this.getresponse.respData
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
          //this.modalService.dismissAll(this.showModalDeleteBoxTemplate);

          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }

}
